import type { ReactNode } from 'react';
import Footer from '@/components/Footer';

const AccountPortalLayout = ({ children, companyName }: { children: ReactNode; companyName?: string }) => {
  return (
    <div className='flex flex-col justify-between h-screen items-center'>
      <img
        className='mx-auto w-1/3 md:w-1/3 lg:w-1/4 xl:w-60 p-5'
        src='https://assets.seinterminal.com/images/logos/SEIN_Terminal_Logo_Color.png'
        alt='sein terminal logo'
      />
      {/* <h2 className="lg:text-xl md:mt-16">Welcome to {companyName} portal</h2> */}
      {children}
      <div className='w-full'>
        <Footer />
      </div>
    </div>
  );
};

export default AccountPortalLayout;
